
import {Component, OnInit} from '@angular/core';
import { usuario } from './../models/user';
import { ServerService } from "../server.service";
import { MatSlideToggleChange } from '@angular/material';
import Swal from 'sweetalert2'
import {Router} from '@angular/router';


@Component({
  selector: 'app-crudusuario',
  templateUrl: './crudusuario.component.html',
  styleUrls: ['./crudusuario.component.css']
})
export class CRUDusuarioComponent implements  OnInit { //implementar el Onit para que jale desde el inciio los usuarisos
  listado: usuario[] = [];
  messageError = '';
  rol: string="";
  filterPost='';
//para el reseteo
  new_pass:string="";
  carnetglobal:String="" //para mensaje en sweetboton
  constructor(private server: ServerService,private router:Router) {

  }

  ngOnInit(): void {
    this.messageError = '';
    const item = localStorage.getItem('usuario');
    //const usuario: usuario =  item == undefined ? null : JSON.parse(item);
    this.server.getUsuarios().subscribe((data: any)=> {

     // console.log(data)
      this.listado = data;
      this.listado.forEach(element => {
      if(element.idRol==2){
        element.idRol="Docente"

      }else {
        element.idRol="Estudiante"
      }

      });
     // console.log(this.listado)
    },error => {
      console.log(error);
    });

  }


  toggle(event: MatSlideToggleChange, usuario) {
    	console.log(usuario)
      this.server.putActualizarEstado(usuario.estado, usuario.carnet).subscribe((data: {msg:string})=> {
       if(data["status"] === 'error'){
         // console.log("no se actualizó")
           return;
     }
       // si se actualizó
    setTimeout(() => location.href='/crud-usuario', 1000);

       }
      , error => {

         alert("Error en la conexion");
        console.log(error, 'error');

      })

  }//fin de toggle


  reseteo(carnet:String):void{
    const bandera=1;
    this.carnetglobal= carnet;
    this.generarpass();
    this.server.putReseteoPass(carnet,bandera, this.new_pass).subscribe((data:any)=> {
    console.log(data)

      if(data["status"] === 'no existe'){ //false
       this.messageError = 'No se encontró el carnet';
      return;
     }
     {
        this.opensweetalert();

    }
   }, error => {
    console.log(error.status)
     if ( error.status === 500 ){   // error.status
        this.messageError = 'el carnet no existe';
        console.log("el carnet no existe")
     }

     else{
       this.messageError = 'Problemas en la conexión';
    }

   })

  }


generarpass():any {
  var length          = 8;
 var result           = '';
 var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
 var charactersLength = characters.length;
 for ( var i = 0; i < length; i++ ) {
   result += characters.charAt(Math.floor(Math.random() *charactersLength));
}
this.new_pass= result;
//this.opensweetalert();
return result;
}

opensweetalert():void{
  Swal.fire({
    position: 'top',
    icon: 'success',
    text: 'Contraseña actualizada para el carnet: ' +this.carnetglobal,
    title: 'contraseña: '+ this.new_pass,
    showConfirmButton: true,
    confirmButtonText: 'Ok!'
  })
}

logout():void {
  localStorage.removeItem('usuario');
  this.router.navigate(['/login']);
}

}

